export default __webpack_public_path__ + "static/media/daily_path_empty_icon.68669250.svg";